// Immutably write a field-level boxAnimation / boxExitAnimation into an
// atomic element JSON at a dot-path produced by extractAnimations.
// Promotes plain strings to { text, [tail]: spec } and collapses
// { text: "..." } back to a plain string when no animation remains.

const ENTRY_KEY = "boxAnimation";
const EXIT_KEY = "boxExitAnimation";

function isPlainObject(x) {
  return x !== null && typeof x === "object" && !Array.isArray(x);
}

function applyAtLeaf(parent, tail, spec) {
  if (typeof parent === "string") {
    if (spec == null) return parent;
    return { text: parent, [tail]: spec };
  }
  if (!isPlainObject(parent)) {
    if (spec == null) return parent;
    return { text: String(parent), [tail]: spec };
  }

  const next = { ...parent };
  if (spec == null) {
    delete next[tail];
  } else {
    next[tail] = spec;
  }

  const keys = Object.keys(next);
  if (keys.length === 1 && keys[0] === "text" && typeof next.text === "string") {
    return next.text;
  }
  return next;
}

function setIn(node, keys, idx, applyFn) {
  if (idx >= keys.length) {
    return applyFn(node);
  }
  const key = keys[idx];
  const numericIdx = /^\d+$/.test(key) ? parseInt(key, 10) : null;

  if (numericIdx != null) {
    const arr = Array.isArray(node) ? node.slice() : [];
    const childOriginal = arr[numericIdx];
    const child = childOriginal === undefined ? {} : childOriginal;
    arr[numericIdx] = setIn(child, keys, idx + 1, applyFn);
    return arr;
  }

  const baseObj = isPlainObject(node) ? node : {};
  const next = { ...baseObj };
  const childOriginal = next[key];
  const child = childOriginal === undefined ? {} : childOriginal;
  next[key] = setIn(child, keys, idx + 1, applyFn);
  return next;
}

export function setNestedAnimation(element, path, type, animSpec) {
  if (!element || typeof element !== "object") return element;
  const tail = type === "entry" ? ENTRY_KEY : EXIT_KEY;
  const keys = (path || "").split(".").filter(Boolean);
  if (keys.length === 0) return element;
  return setIn(element, keys, 0, (leaf) => applyAtLeaf(leaf, tail, animSpec));
}

export default setNestedAnimation;
